export const GuiaDetallePanelStyles = {
    'root':{
        // width: '340px',
        backgroundColor: '#3286EA'
    },
    'drawerHeader': {
        padding: '10px',
      },
    
    'detalle': {
        padding: '0px 30px 30px 30px',
        color:'#000000'
    }
    
}